import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as myAccountActions from '../my-account/redux/actions';
import * as serviceActions from '../pb-service-list/redux/actions';

import React, { Component } from 'react';
import { Theme3, ThemeElevenContact, ThemePopup } from '../themes';
import { Trans, withTranslation } from 'react-i18next';

import ApiUrls from '../../services/apiUrls';
import BusCompanies from './BusCompanies';
import CommonService from '../../services/commonService';
import Cormarbus from '../themes/Cormarbus/Cormarbus';
import DateService from '../../services/dateService';
import HomeBanner from './HomeBanner';
import HomeSearchBoxPB from './HomeSearchBoxPB';
import { KuposErrorSuccessModal } from '../common';
import KuposHelmet from '../common/KuposHelmet';
// import MyAccount from '../themes/my-account/MyAccount';
import { PopupMessage } from '../common/PopupMessage';
import PropTypes from 'prop-types';
import Tarapaca from '../themes/Tarapaca/Tarapaca';
import Theme1 from '../themes/themes1/Theme1';
import Theme10 from '../themes/ThemeTen/Theme10';
import Theme4 from '../themes/theme4/Theme4';
import Theme5 from '../themes/theme5/Theme5';
import Theme6 from '../themes/theme6/Theme6';
import ThemeEight from '../themes/ThemeEight/ThemeEight';
import ThemeEleven from '../themes/ThemeEleven/ThemeEleven';
import ThemeFour from '../themes/ThemeFour/ThemeFour';
import ThemeNine from '../themes/ThemeNine/ThemeNine';
import ThemeSeven from '../themes/ThemeSeven/ThemeSeven';
import ThemeThree from '../themes/ThemeThree/ThemeThree';
import ThemeTwo from '../themes/ThemeTwo/ThemeTwo';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import moment from 'moment';

const cities = [
	{ value: '1', label: 'Santiago' },
	{ value: '2', label: 'Puerto mont' },
	{ value: '3', label: 'Vina del mar' },
];

export class DefaultPage extends Component {
	static propTypes = {
		home: PropTypes.object.isRequired,
		actions: PropTypes.object.isRequired,
		history: PropTypes.object,
	};

	constructor(props) {
		super(props);
		this.props.actions.setOnwardPbDate(DateService.getTodayString());
		CommonService.removeLocal('home');
		CommonService.removeLocal('pbServiceList');
		this.props.actions.setServiceOnward({
			coachLayoutJson: null,
			originStageDetails: null,
			destinationStageDetails: null,
			boardingStage: null,
			droppingStage: null,
			route: null,
		});
		this.props.actions.setServiceReturn({
			coachLayoutJson: null,
			originStageDetails: null,
			destinationStageDetails: null,
			boardingStage: null,
			droppingStage: null,
			route: null,
		});
		this.props.actions.selectSeatOnward({
			totalBookingAmount: 0,
			netBookingAmount: 0,
			discountAmount: 0,
			selectedSeatsToBook: null,
			selectedSeatsNumbers: null,
			selectedSeatTypes: null,
		});
		this.props.actions.selectSeatReturn({
			totalBookingAmount: 0,
			netBookingAmount: 0,
			discountAmount: 0,
			selectedSeatsToBook: null,
			selectedSeatsNumbers: null,
			selectedSeatTypes: null,
		});
		this.state = {
			bipEmail: null,
			KupoGoSelected: false,
			kuposGoSearchBody: false,
		};

		//GET AT SEAT TYPES
		// this.props.actions
		//   .apiCall({
		//     url: AppData.AT_URL + 'api/v1/master_data/SEAT/TYPE',
		//     // type: 'home',
		//     method: 'GET',
		//   })
		//   .then(
		//     res => this.onGetATSeatDetails(res),
		//     err => this.onGetATSeatDetails(err),
		//   );
	}

	onGetATSeatDetails = res => {
		if (res && res.data && res.data.success && res.data.data) {
			this.props.actions.setAtMastersData(res.data.data);

			// if (
			//   res.data.data &&
			//   res.data.data.kupos_popup_details &&
			//   res.data.data.kupos_popup_details[0] &&
			//   res.data.data.kupos_popup_details[0].status
			// ) {
			//   this.setState({
			//     showFlashMessage: res.data.data.kupos_popup_details[0].popup_type === 1 ? true : false,
			//     showPopupMessage: res.data.data.kupos_popup_details[0].popup_type === 2 ? true : false,
			//     popupData: res.data.data.kupos_popup_details[0],
			//   });
			// }
		}
	};

	componentDidMount() {
		sessionStorage.setItem('serviceListAttempts', 0);
		sessionStorage.setItem('serviceDetailsAttempts', 0);
	}

	componentWillUnmount() { }

	renderMainLoader = () => {
		return (
			<div className="main-app-loader content-container">
				<span>Loading..</span>
			</div>
		);
	};
	render() {
		const { t, history } = this.props;
		// console.log('props in default page--------------', this.props);
		// const operator = CommonService.getLocal('op');
		const operator = this.props.home.operator ? this.props.home.operator : '';
		console.log('props in default page--------------', this.props);
		return (
			<div className="home-default-page">
				{operator && <ThemePopup operator={operator} />}

				<KuposHelmet />

				{!operator && this.renderMainLoader()}

				{operator && operator.theme_type === 6 && <Theme6 history={history} operator={operator} />}

				{operator && operator.theme_type === 5 && (
					<Theme5 history={history} operator={operator} actions={this.props.actions} />
				)}

				{operator && operator.operator_name === 'tarapaca' && (
					<Tarapaca history={history} operator={operator} actions={this.props.actions} />
				)}
				{operator && operator.operator_name === 'cormarbus' && (
					<Cormarbus history={history} operator={operator} actions={this.props.actions} />
				)}

				{operator && operator.theme_type === 2 && operator && operator.operator_name !== 'tarapaca' && operator && operator.operator_name !== 'cormarbus' && (
					<ThemeTwo history={history} operator={operator} actions={this.props.actions} />
				)}


				{operator && operator.theme_type === 1 && (
					<Theme1 history={history} operator={operator} actions={this.props.actions} />
				)}
				{operator && operator.theme_type === 4 && (
					<ThemeFour history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 3 && (
					<ThemeThree history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 7 && (
					<ThemeSeven history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 8 && (
					<ThemeEight history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 9 && (
					<ThemeNine history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 10 && (
					<Theme10 history={history} operator={operator} />
				)}

				{operator && operator.theme_type === 11 && (
					<ThemeEleven history={history} operator={operator} actions={this.props.actions} />
				)}

			</div>
		);
	}
}

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
		common: state.common,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(
			{
				...actions,
				...serviceActions,
				...myAccountActions,
				...commonActions,
			},
			dispatch,
		),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js